<content *ngIf="dataGrid">
    <section class="entry-inline-framed" *ngIf="currentTab !== 'regularTab'">
        <label *ngIf="currentTab === 'kgCampanyasDenominaciones'">{{'centralEstadisticas.pais' | translate}} {{desPais}} </label>
        <label *ngIf="currentTab === 'kgCampanyasPaises'">{{'centralEstadisticas.denominacion' | translate}} {{desDenominacion}}</label>
    </section>
    <table>
        <thead>
            <tr>
                <th class="string" *ngIf="showPais">{{'global.pais' | translate}}</th>
                <th class="string" *ngIf="showDenominacion">{{'centralEstadisticas.grid.denominacion' | translate}}</th>
                <th class="string" *ngIf="showCampanya">{{'centralEstadisticas.grid.campanya' | translate}}</th>
                <th class="string-long" *ngIf="showDesignaciones">{{'centralEstadisticas.designaciones.designacionesNum' | translate}}</th>
                <th class="string" *ngIf="showPorcentaje">{{'centralEstadisticas.designaciones.designacionesPorcentaje' | translate}}</th>
                <th class="string" *ngIf="currentTab !== 'regularTab'">{{'centralEstadisticas.designaciones.designadosKg' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngFor="let row of dataGrid; let i = index">
            <tr *ngIf="i < lastItemList && i >= firstItemList">
                <td class="string" *ngIf="showPais">{{row.desPais}}</td>
                <td class="string" *ngIf="showDenominacion">{{row.desDenominacion}}</td>
                <td class="string" *ngIf="showCampanya">{{row.anyo}}</td>
                <td class="number" *ngIf="showDesignaciones">{{row.numDesignaciones ? row.numDesignaciones : row.numero}}</td>
                <td class="number" *ngIf="showPorcentaje">{{row.porcentajeDesignaciones ? row.porcentajeDesignaciones : row.porcentaje}}</td>
                <td class="string" *ngIf="currentTab !== 'regularTab'">{{row.kilos | number : '1.0-2': defaultLanguage}}</td>
            </tr>
        </tbody>
        <tfoot *ngIf="!dataGrid || (dataGrid && dataGrid.length < 1)">
            <tr>
                <td colspan="4">
                    {{'global.noContent' | translate}}
                </td>
            </tr>
        </tfoot>
    </table>
    <app-paginator
        *ngIf="(dataGrid && dataGrid.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer *ngIf="dataGrid" class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
